var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKyc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 82.046,
    viewBox: "0 0 82 82.046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "biometric_10394862",
    transform: "translate(-7.998 -7.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M335.211,320.141a15.21,15.21,0,1,0,15.21,15.21A15.23,15.23,0,0,0,335.211,320.141Zm5.347,10.567a1.322,1.322,0,0,1,.936,2.258l-6.641,6.64a1.323,1.323,0,0,1-1.916-.048l-4.054-4.485a1.322,1.322,0,1,1,1.962-1.773l3.122,3.452,5.656-5.658a1.324,1.324,0,0,1,.935-.387Z",
    transform: "translate(-260.422 -260.657)",
    fill: "#3768e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M82.6,128.182a7.4,7.4,0,1,0,7.408,7.4A7.427,7.427,0,0,0,82.6,128.182Zm0,2.644a4.76,4.76,0,1,1-4.763,4.76A4.74,4.74,0,0,1,82.6,130.826Z",
    transform: "translate(-56.082 -100.432)",
    fill: "#3768e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M68.943,201.766A10.236,10.236,0,0,0,58.83,212.082a1.323,1.323,0,1,0,2.646,0,7.47,7.47,0,1,1,14.935,0,1.322,1.322,0,1,0,2.644,0A10.235,10.235,0,0,0,68.943,201.766Z",
    transform: "translate(-42.428 -161.851)",
    fill: "#3768e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M11.47,88.172A3.494,3.494,0,0,0,8,91.644v7.1a1.323,1.323,0,1,0,2.646,0v-7.1a.8.8,0,0,1,.826-.827H19.9a1.322,1.322,0,1,0,0-2.644Zm20.335,0a1.322,1.322,0,1,0,0,2.644h9.753a.8.8,0,0,1,.826.827v7.1a1.323,1.323,0,1,0,2.646,0v-7.1a3.494,3.494,0,0,0-3.472-3.472Zm-22.484,23.8A1.322,1.322,0,0,0,8,113.3v8.436A3.493,3.493,0,0,0,11.47,125.2H19.9a1.322,1.322,0,1,0,0-2.645H11.47a.8.8,0,0,1-.826-.826V113.3a1.322,1.322,0,0,0-1.323-1.323Zm34.387,0a1.322,1.322,0,0,0-1.323,1.323v8.436a.8.8,0,0,1-.826.826H31.805a1.322,1.322,0,1,0,0,2.645h9.753a3.493,3.493,0,0,0,3.472-3.471V113.3a1.322,1.322,0,0,0-1.323-1.323Z",
    transform: "translate(0 -67.037)",
    fill: "#3768e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M291.484,410.736a1.331,1.331,0,1,0-1.331-1.331A1.331,1.331,0,0,0,291.484,410.736Z",
    transform: "translate(-235.509 -334.052)",
    fill: "#3768e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M261.434,410.736A1.331,1.331,0,1,0,260.1,409.4,1.331,1.331,0,0,0,261.434,410.736Z",
    transform: "translate(-210.427 -334.052)",
    fill: "#3768e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M118.374,346.635a1.322,1.322,0,1,0,0,2.644h31.1a1.322,1.322,0,0,0,0-2.644Z",
    transform: "translate(-91.024 -282.771)",
    fill: "#3768e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M214.862,374.672a1.322,1.322,0,1,0,0,2.644h8.749a1.322,1.322,0,1,0,0-2.644Z",
    transform: "translate(-171.561 -306.172)",
    fill: "#3768e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M227.323,39.732a1.322,1.322,0,1,0,0,2.645h4.629a1.322,1.322,0,1,0,0-2.645Z",
    transform: "translate(-181.962 -26.605)",
    fill: "#3768e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M115.8,7.857a3.786,3.786,0,0,0-3.844,3.687v6.735a1.323,1.323,0,1,0,2.646,0V11.544a1.1,1.1,0,0,1,1.2-1.041h37.341a1.1,1.1,0,0,1,1.2,1.041V56.028a1.322,1.322,0,1,0,2.644,0V11.544a3.786,3.786,0,0,0-3.843-3.687ZM113.28,59.311a1.322,1.322,0,0,0-1.323,1.322V72.982A3.788,3.788,0,0,0,115.8,76.67h16.956a1.323,1.323,0,1,0,0-2.646H115.8a1.1,1.1,0,0,1-1.2-1.042V60.633a1.322,1.322,0,0,0-1.323-1.322Z",
    transform: "translate(-86.772)",
    fill: "#3768e1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyc);
export default __webpack_public_path__ + "static/media/kyc.fb3cbbec6f36c63e41224e3e9da3ba88.svg";
export { ForwardRef as ReactComponent };